import React, { useEffect, useState } from "react";
import { fetchSecure } from "../utils/utils";
import CustomChatbotIcons from "./CustomChatbotIcons";

const SecureImage = (props) => {
  // console.log("🚀 ~ SecureImage ~ props:", props);
  const [source, setSource] = useState("");
  // let data = props?.field
  // let sample_type = data?.sample_type
  const url = props?.url;
  const imageData = props?.imageData;

  useEffect(() => {
    const getSourceResp = async () => {
      if (url.startsWith("/api/getFile/")) {
        const modifiedUrl = url.replace("/api/getFile", "/api/getFileImage");

        const response = await fetchSecure(modifiedUrl);

        var data = await response.json();

        setSource(data[0].src);
      } else {
        setSource(props.url);
      }
    };

    getSourceResp();
  }, [props.url]);

  return (
    <>
      {/* Vik (May 9, 2025): Added Condition check for base64 images */}
      {source.startsWith("https://") ||
      source.startsWith("/") ||
      source.startsWith("data:image/") ? (
        <img src={source} width={imageData && imageData.width?imageData.width:"50px"} alt="" />
      ) : (
        <CustomChatbotIcons
          name={url}
          color={imageData?.color}
          secondaryColor={imageData?.secondaryColor} // Added secondaryColor prop
          height={imageData?.height}
          width={imageData?.width}
        />
      )}
    </>
  );
};

export default SecureImage;
